import { GenericLazyString } from '@eventbrite/i18n';
import React, { FunctionComponent } from 'react';
import { TicketsFormat } from '../../../constants/statsig';
import TicketQuantitySelector, {
    TicketQuantitySelectorProps,
} from '../TicketQuantitySelector';
import TicketStepperSelector from '../TicketStepperSelector';

export interface TicketSelectorSwitcherProps {
    id: string;
    name: TicketQuantitySelectorProps['name'];
    displayPrice: GenericLazyString | string | null;
    selectedQuantity: number;
    isDisabled: boolean;
    onQuantityChange: (quantity: string) => void;
    ticketOptionsRange: number[];
    ticketsFormat: TicketsFormat;
}

export const TicketSelectorSwitcher: FunctionComponent<
    TicketSelectorSwitcherProps
> = ({
    displayPrice,
    id,
    isDisabled,
    name,
    onQuantityChange,
    selectedQuantity,
    ticketOptionsRange,
    ticketsFormat,
}) =>
    ticketsFormat === TicketsFormat.card ? (
        <TicketStepperSelector
            variantId={id}
            selectedQuantity={selectedQuantity}
            isDisabled={isDisabled}
            onQuantityChange={(newQuantity) => {
                // We convert `newQuantity` into a string to match `TicketQuantitySelector` API.
                // `TicketQuantitySelector` uses a `select` HTML input element underneath and when changing the value
                // the `select` element emits a string. However, the new stepper works always with numbers and emits
                // a number, so we wrap it into a string to keep the same API. In the future when we remove
                // `TicketQuantitySelector` we should remove the string wrapping and only pass numbers around
                onQuantityChange(`${newQuantity}`);
            }}
            ticketOptionsRange={ticketOptionsRange}
        />
    ) : (
        <TicketQuantitySelector
            id={id}
            name={name}
            displayPrice={displayPrice?.toString() ?? null}
            selectedQuantity={selectedQuantity}
            isDisabled={isDisabled}
            onQuantityChange={onQuantityChange}
            ticketOptionsRange={ticketOptionsRange}
        />
    );

export default TicketSelectorSwitcher;
